import { Button, Stack, Typography } from "@mui/material";
import { useUnfollowUserMutation } from "Api/Mutations/Social/useUnfollowUserMutation";
import { SocialSummaryRow } from "Components/Social/SocialSummaryRow";
import { SocialUserActionsMenu } from "Components/Social/SocialUserActionsMenu";
import type { FollowRequestDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.People;

type Props = {
  requests: ReadonlyArray<FollowRequestDto>;
};

/**
 * The caller's own pending requests: each can be withdrawn, which is an unfollow. The caller
 * sent them, so they have a handle already — no HandleGate here.
 */
export const OutgoingFollowRequestsList = ({ requests }: Props) => {
  const { t } = useResource();
  const { mutate: withdraw, isPending: isWithdrawing } =
    useUnfollowUserMutation();

  return (
    <Stack gap={2}>
      <Typography variant="caption" color="text.secondary">
        {t(RESOURCES.OutgoingTitle)}
      </Typography>
      {requests.map(({ user }) => (
        <SocialSummaryRow
          key={user.identityUserPublicID}
          user={user}
          action={
            <>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled={isWithdrawing}
                onClick={() => withdraw(user.identityUserPublicID)}
              >
                {t(RESOURCES.CancelRequest)}
              </Button>
              <SocialUserActionsMenu
                identityUserPublicID={user.identityUserPublicID}
                handle={user.handle}
                displayName={user.displayName}
                isBlockVisible
                isDisabled={isWithdrawing}
              />
            </>
          }
        />
      ))}
    </Stack>
  );
};
